import { Http } from '../../axios';

export const assignReleases = async ({ type, identification, identificationType, releaseAddresses, visitNumber, anonAddresses }) => {
  return await Http.update('releases/assignment/assign', {
    type,
    identification,
    identificationType,
    releaseAddresses,
    visitNumber,
    includeadr: anonAddresses
  })
};

export const unAssignReleases = async ({ releaseAddresses, anonAddresses }) => {
  return await Http.update('releases/assignment/unassign', {
    releaseAddresses,
    includeadr: anonAddresses
  })
};

export const transferToPcs = async ({ releaseAddresses, anonAddresses }) => {
  return await Http.update('releases/pcs/transferToPcs', {
    releaseAddresses,
    includeadr: anonAddresses
  })
};

export const revokeFromPcs = async ({ releaseAddresses, anonAddresses }) => {
  return await Http.update('releases/pcs/revokeFromPcs', {
    releaseAddresses,
    includeadr: anonAddresses
  })
};

export const checkIsReleaseAssigned = async ({ releaseAddresses, anonAddresses }) => {
  return await Http.update('releases/assignment/info', {
    releaseAddresses,
    includeadr: anonAddresses
  })
};

export const checkAssignLocations = async ({ releaseAddresses, anonAddresses }) => {
  return await Http.update('releases/assignment/check', {
    releaseAddresses,
    includeadr: anonAddresses
  })
};

export const getReleaseAuditTrail = async ({ releaseAddresses, anonAddresses }) => {
  return await Http.post('audit-trail', {
    releaseAddresses,
    includeadr: anonAddresses
  });
};
